import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Calculator } from 'lucide-react';
import { useAppContext } from '../store';

interface StickySimulatorCTAProps {
  darkMode: boolean;
}

const StickySimulatorCTA: React.FC<StickySimulatorCTAProps> = ({ darkMode }) => {
  const { state } = useAppContext();
  const { cartItems } = state.searchAndFilter;
  const navigate = useNavigate();

  if (cartItems.length === 0) {
    return null;
  }

  const handleNavigateToSimulator = () => {
    navigate('/simulateur');
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="absolute inset-0 bg-gradient-to-t from-appines-petrol/20 to-transparent pointer-events-none" />
      
      <div className="relative p-4 md:p-6">
        <div className={`rounded-xl shadow-2xl border-2 overflow-hidden ${
          darkMode 
            ? 'bg-appines-petrol border-appines-emerald' 
            : 'bg-appines-white border-appines-emerald'
        }`}>
          <div className="p-4 md:p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center flex-1">
                <div className="p-2 md:p-3 bg-appines-glass/25 rounded-lg mr-3 md:mr-4">
                  <Calculator className="h-6 w-6 md:h-8 md:w-8 text-appines-petrol" />
                </div>
                <div className="flex-1">
                  <p className={`font-semibold text-sm md:text-base ${
                    darkMode ? 'text-appines-white' : 'text-appines-black'
                  }`}>
                    {cartItems.length} acte{cartItems.length > 1 ? 's' : ''} dans ton panier
                  </p>
                  <p className={`text-xs md:text-sm ${
                    darkMode ? 'text-appines-white/65' : 'text-appines-petrol/65'
                  }`}>
                    Calcule tes revenus maintenant !
                  </p>
                </div>
              </div>

              <button
                onClick={handleNavigateToSimulator}
                className="flex items-center px-4 py-3 md:px-6 md:py-4 bg-appines-emerald hover:bg-[#22b886] text-appines-petrol font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105 ml-3 md:ml-4"
              >
                <span className="text-sm md:text-base">Simule tes revenus</span>
                <span className="ml-2">👉</span>
              </button>
            </div>
          </div>

          <div className={`h-1 ${
            darkMode ? 'bg-appines-white/10' : 'bg-[rgba(1,42,54,0.1)]'
          }`}>
            <div 
              className="h-full bg-appines-emerald transition-all duration-300"
              style={{ width: `${Math.min((cartItems.length / 5) * 100, 100)}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickySimulatorCTA;
